import { cookieDomainForHost, QUIZ_ID_COOKIE_EXPIRY_DAYS, QUIZ_ID_COOKIE_NAME } from 'components/constants'
import { useQuizService } from 'contexts/QuizServiceContext'
import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useSelector } from 'react-redux'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { selectQuiz, selectQuizCountry } from 'redux/quiz/slice'
import { QuizVersion } from '../../config/types'

export interface EntryScreenProps extends RouteComponentProps {
  to: string
  quizVersion: QuizVersion
}

export const cookieExpiryDate = (numberOfDays: number = QUIZ_ID_COOKIE_EXPIRY_DAYS): Date =>
  new Date(Date.now() + numberOfDays * 24 * 60 * 60 * 1000)
export const cookieDomain = cookieDomainForHost(window.location.hostname)

export const EntryScreen: React.FC<EntryScreenProps> = ({ to, location, quizVersion }) => {
  const quiz = useSelector(selectQuiz)
  const { quizApi } = useQuizService()
  const quizCountry = useSelector(selectQuizCountry)

  const [_, setCookie] = useCookies([QUIZ_ID_COOKIE_NAME])

  useEffect(() => {
    if (quiz.id) {
      setCookie(QUIZ_ID_COOKIE_NAME, quiz.id, { path: '/', expires: cookieExpiryDate(), domain: cookieDomain })
    }

    const submitQuizVersion = async () => {
      try {
        await quizApi.answers({
          user_id: quiz.id,
          quiz_version: quizVersion,
          answers: [{ question_key: 'quiz_version', answer: quizVersion }],
          quiz_country: quizCountry,
        })
      } catch (error) {
        console.error(error)
      }
    }

    submitQuizVersion()
  }, [quiz.id, quizVersion, quizCountry, quizApi, setCookie])

  return <Redirect to={{ pathname: to, search: location?.search }} />
}
